import React, { createContext, useContext } from 'react';

const TransportContext = createContext(null);

export const TransportProvider = ({ children, transport }) => {
  return (
    <TransportContext.Provider value={{ transport }}>
      {children}
    </TransportContext.Provider>
  );
};

export const useTransport = () => {
  const context = useContext(TransportContext);
  if (!context) {
    throw new Error('useTransport must be used within a TransportProvider');
  }
  return context.transport;
};

export default TransportContext;
